import { useTranslation } from "react-i18next";
export const youtubeChannelLink = 'https://www.youtube.com/channel/UC_8tWfEtsz5JxEUy-yyYkJA'

export const social = [
  { name: "instagram", href: 'https://www.instagram.com/elementalclinic?igsh=MTJib2draTc3anB6dQ%3D%3D&utm_source=qr', icon: 'insta' },
  { name: "whatsapp", href: "https://wa.me/97143830500?text=Здравствуйте!%20Пишу%20с%20сайта%20—%20https://elemental.ae/", icon: "whatsapp" },
  { name: "youtube", href: "https://www.youtube.com/@ELEMENTAL_CLINIC_AE", icon: "youtube" },
  { name: "facebook", href: 'https://www.facebook.com/profile.php?id=61590759771392', icon: 'fb' },
]
export const socialContacts = [
  { name: "WhatsApp", href: "https://wa.me/97143830500?text=Здравствуйте!%20Пишу%20с%20сайта%20—%20https://elemental.ae/", icon: "whatsapp-icon" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61590759771392", icon: "fb" },
]

export const phones = [{
  title: '043830500',
  href: 'tel:043830500',
  icon: "phone-icon",
}]

export const email = {
  title: 'appointment@elemental.ae',
  href: 'mailto:appointment@elemental.ae',
  icon: "email-icon",
}

export const emailFooter = {
  title: 'info@elemental.ae',
  href: 'mailto:info@elemental.ae',
  icon: "email-icon",
}

export const legalLinks = {
  newsletter: '/mail.pdf',
  publicOffer: '/oferta.pdf',
  personalDataInstruction: '/personal-data-instruction.pdf',
  personalDataProcessingPolicy: '/Patient Rights and Responsibilities.pdf',
}

export const formErrors = {
  phone: {
    required: 'Required field',
    pattern: 'The number can only include digits',
  },
  email: {
    validate: 'The data entered is incorrect',
  },
  message: {
    required: 'Please add a message',
  },
  review: {
    required: 'Don’t forget to write a review',
  },
  default: {
    required: 'Required field',
  },
}

export const regExp = {
  phone: /^\+375\s\((29|25|44|33|17)\)\s\d{3}(-\d{2}){2}$/,
  phoneSimple: /^[\d]+$/,
  email:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  date: /^(((0[1-9]|[12]\d|3[01])\-(0[13578]|1[02])\-((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\-(0[13456789]|1[012])\-((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\-02\-((19|[2-9]\d)\d{2}))|(29\-02\-((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/,
}
